export default __webpack_public_path__ + "_/images/app/manual/manual6-32622c6cc7fd6353d5a211599ae71db8e1244a4008163556234506b6c1018b69.png";